export default "__VITE_ASSET__8500bf47__"